<template>
  <div id="game_03">
    <!--  ゲーム画面  -->
    <div class="game_wrapper">
      <div class="game" :style="{ backgroundImage: `url(${publicPath}img/game/03/bg_frame.png)`}">
        <div class="heart_wrapper">
          <div class="heart" :style="{ backgroundImage: `url(${publicPath}img/game/03/heart.png)`}"></div>
        </div>
        <div class="chara"><span class="left" :style="{ backgroundImage: `url(${publicPath}img/game/03/chara_01.png)`}"></span><span class="right" :style="{ backgroundImage: `url(${publicPath}img/game/03/chara_02.png)`}"></span></div>
        <div class="pomp"><span class="pull" :style="{ backgroundImage: `url(${publicPath}img/game/03/pomp_01.png)`}"></span><span class="push" :style="{ backgroundImage: `url(${publicPath}img/game/03/pomp_02.png)`}"></span></div>
      </div>

      <div class="result">
        <div class="image_wrapper">
          <div class="correct" :style="{ backgroundImage: `url(${publicPath}img/game/03/result_clear.png)`}"></div>
          <div class="failed_01" :style="{ backgroundImage: `url(${publicPath}img/game/03/result_failed_01.png)`}"></div>
          <div class="failed_02" :style="{ backgroundImage: `url(${publicPath}img/game/03/result_failed_02.png)`}"></div>
        </div>

        <div class="chara_wrapper">
          <div class="correct" :style="{ backgroundImage: `url(${publicPath}img/game/03/bg_result_clear.png)`}">
            <div class="chara" :style="{ backgroundImage: `url(${publicPath}img/game/03/chara_correct.png)`}"></div>
          </div>
          <div class="failed" :style="{ backgroundImage: `url(${publicPath}img/game/03/chara_failed.png)`}"></div>
        </div>
      </div>
    </div>

    <div class="txt" :style="{ backgroundImage: `url(${publicPath}img/game/03/bg_txt.png)`}">
      <div class="txt_01" :style="{ backgroundImage: `url(${publicPath}img/game/03/txt.png)`}"></div>
      <div class="txt_correct" :style="{ backgroundImage: `url(${publicPath}img/game/03/txt_correct.png)`}"></div>
      <div class="txt_failed_01" :style="{ backgroundImage: `url(${publicPath}img/game/03/txt_failed_01.png)`}"></div>
      <div class="txt_failed_02" :style="{ backgroundImage: `url(${publicPath}img/game/03/txt_failed_02.png)`}"></div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'

  export default {
    data() {
      return {
        // 変更不可 -------------------------
        publicPath: process.env.BASE_URL,
        // ---------------------------------
        step: 1,
        state: {
          size: 3, // 初期 30%
          result: 0
        }, 
        balloonTiming: 500,
        animeTiming: 1000,
        animeTimer: '',
        balloonTimer: '',
        delay: 0,
        sendDelay: 1000,
        posB: 13.33,
        result: false
      }
    },
    mounted () {
      // let vh = window.innerHeight * 0.01;
      // document.documentElement.style.setProperty('--vh', `${vh}px`)

      $('#game_03').on('touchstart', this.start)
      $('#game_03').on('touchend', this.end)
      $('#game_03').on('contextmenu', this.cancel)
    },
    destroyed () {
      $('#game_03').off('touchstart', this.start)
      $('#game_03').off('touchend', this.end)
      $('#game_03').off('contextmenu', this.cancel)
    },
    methods: {
      start() {
        if(this.step != 1) return

        this.step++
        
        // キャラクターアニメーション
        this.animeTimer = setInterval(() => {
          $('#game_03 .game .chara').toggleClass('on')
          $('#game_03 .game .pomp').toggleClass('on')
        }, this.animeTiming)

        // バルーンアニメーション
        this.balloonTimer = setInterval(() => {
          this.state.size++
          this.posB = this.posB - 1.9
          const size = this.state.size * 10 + '%'

          if(this.state.size > 10) {
            this.end()
            return
          }

          $('#game_03 .heart').css({
            bottom: this.posB +'vw',
            width: size,
            height: size
          })
        }, this.balloonTiming)
      },
      end() {
        if(this.step != 2) return

        this.step++

        clearInterval(this.animeTimer)
        clearInterval(this.balloonTimer)

        switch(true) {
          case this.state.size === 10:
            this.state.result = 1
            break
          case this.state.size < 10:
            this.state.result = 2
            break
          case this.state.size > 10:
            this.state.result = 3
            break
        }

        setTimeout(this.displayResult, this.delay)
      },
      displayResult() {
        $('#game_03 .game').hide()
        $('#game_03 .txt div').hide()
        
        switch(this.state.result) {
          case 1:
            this.result = true
            $('#game_03 .result .image_wrapper .correct').show()
            $('#game_03 .result .chara_wrapper .correct').show()
            $('#game_03 .txt .txt_correct').show()
            break
          case 2:
            $('#game_03 .result .image_wrapper .failed_01').show()
            $('#game_03 .result .chara_wrapper .failed').show()
            $('#game_03 .txt .txt_failed_01').show()
            break
          case 3:
            $('#game_03 .result .image_wrapper .failed_02').show()
            $('#game_03 .result .chara_wrapper .failed').show()
            $('#game_03 .txt .txt_failed_02').show()
            break
        }
        
        $('#game_03 .result').show()

        setTimeout(this.sendResult, this.sendDelay)
      },
      // ゲーム結果を送信 --- クリアの時は「true」、失敗の時は「false」-------------
      sendResult: function(){
        this.$emit('gameResult', this.result);
      }
    }
  }
</script>

<style lang="scss" scoped>
  #game_03 {
    // height: 100vh;
    // height: calc(var(--vh, 1vh) * 100);
    width: 100%;
    height: 100%;
    position: relative;

    * {
      user-select: none;
    }

    .game_wrapper {
      position: relative;
      // 100% - (.txtのheight + 上下margin)
      height: calc(100% - 32.38vw);
    }

    .game {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      width: 89.86vw;
      height: 87.46vw;
      background: left 15.6vw top no-repeat;
      background-size: 59.46vw;

      .heart_wrapper {
        position: absolute;
        top: 1.33vw;
        right: 0;
        left: 0;
        margin: 0 auto;
        width: 56vw;
        height: 57.33vw;

        .heart {
          position: absolute;
          right: 0;
          bottom: 13.33vw;
          left: 0;
          margin: 0 auto;
          width: 30%;
          height: 30%;
          background: left bottom no-repeat;
          background-size: 100%;
        }
      }

      .pomp {
        position: absolute;
        bottom: 0.53vw;
        right: 10vw;
        width: 13.73vw;
        height: 32.53vw;

        span {
          position: absolute;
          left: 0;
          right: 0;
          display: block;
          width: 13.73vw;
          height: 32.53vw;
          background: left bottom no-repeat;
          background-size: 13.73vw;
        }

        .push {
          opacity: 0;
        }

        &.on {
          .pull {
            opacity: 0;
          }

          .push {
            opacity: 1;
          }
        }
      }

      .chara {
        position: absolute;
        bottom: 0;
        left: 11.46vw;
        width: 21.06vw;
        height: 25.2vw;

        span {
          position: absolute;
          left: 0;
          right: 0;
          display: block;
          width: 21.06vw;
          height: 25.2vw;
          background: left top no-repeat;
          background-size: 21.06vw;
        }

        .right {
          opacity: 0;
        }

        &.on {
          .left {
            opacity: 0;
          }

          .right {
            opacity: 1;
          }
        }
      }
    }

    .result {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: none;
      margin: auto;
      width: 89.86vw;
      height: 93.33vw;

      .image_wrapper {
        div {
          display: none;
          margin: 0 auto;
          background-size: 100%;
        }

        .correct {
          width: 56vw;
          height: 57.3vw;
        }

        .failed_01 {
          width: 42.53vw;
          height: 40vw;
        }
        .failed_02 {
          width: 68.93vw;
          height: 56.13vw;
        }
      }

      .chara_wrapper {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 34.4vw;

        & > div {
          position: absolute;
          bottom: 0;
          right: 0;
          left: 0;
          margin: 0 auto;
          display: none;
          background-size: 100%;
        }

        .correct {
          width: 100%;
          height: 100%;
          background: center bottom 7.06vw no-repeat;
          background-size: 77.86vw;

          .chara {
            position: absolute;
            bottom: 0;
            right: 0;
            left: 0;
            margin: 0 auto;
            width: 23.33vw;
            height: 27.73vw;
            background-size: 100%;
          }
        }

        .failed {
          width: 22.28vw;
          height: 27.2vw;
        }
      }
    }

    .txt{
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      margin: 5.06vw auto;
      width: 89.86vw;
      height: 22.26vw;
      background: left top no-repeat;
      background-size: 100% auto;

      div {
        position: relative;
        top: 8vw;
        left: 10vw;
        display: none;
        background: left top no-repeat;
        background-size: 100% auto;
      }

      .txt_01 {
        display: block;
        width: 56.66vw;
        height: 8.8vw;
      }

      .txt_correct {
        width: 9.86vw;
        height: 3.46vw;
      }

      .txt_failed_01 {
        width: 49.86vw;
        height: 3.46vw;
      }

      .txt_failed_02 {
        width: 14.66vw;
        height: 3.46vw;
      }
    }
  }
</style>
